import SkeletonItem from '../skeleton/item';

/* istanbul ignore next */
SkeletonItem.install = function(Vue) {
  Vue.component(SkeletonItem.name, SkeletonItem);
};

export default SkeletonItem;
